import { TableColumn } from 'types/types'
import { TWheatCode } from '../../../../../../types'
import { Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { Input } from 'components'
import * as countryFlags from 'country-flag-icons/react/3x2'
import * as sxStyles from './WheatCodeList.styles'
import { TableActionConfig } from '../../../../../../components/Table/types'
import { TableActions } from '../../../../../../components/Table/TableActions'

export const wheatCodesTableColumns = <T,>(
  actions: TableActionConfig<T>[],
  modifiedFields: Record<number, number>,
  handleCostChange: (id: number, newCost: number | string) => void,
  statusesOptions?: { value: string; label: string }[]
): TableColumn[] => [
  {
    id: 'code',
    label: 'Wheat code',
    filterParams: {
      filterVariant: 'string',
    },
    sortable: true,
    width: 200,
  },
  {
    id: 'vessel',
    label: 'Vessel',
    filterParams: {
      filterVariant: 'string',
    },
    sortable: true,
    width: 150,
  },
  {
    id: 'origin',
    label: 'Origin',
    filterParams: {
      filterVariant: 'string',
    },
    sortable: true,
    width: 120,
    format: (value: TWheatCode['origin']) => {
      const FlagComponent =
        countryFlags[value.toUpperCase() as keyof typeof countryFlags] || null

      return (
        <Stack sx={sxStyles.countryRenderBox}>
          <Box sx={sxStyles.countryIconContainer}>
            {FlagComponent ? <FlagComponent /> : null}
          </Box>
          <Typography sx={sxStyles.countryLabel}>{value}</Typography>
        </Stack>
      )
    },
  },
  {
    id: 'cost',
    label: 'Cost $/T',
    filterParams: {
      filterVariant: 'number',
    },
    sortable: true,
    width: 150,
    format: (value: TWheatCode['cost'], row: TWheatCode) => {
      const currentCost = modifiedFields[row.id] ?? value

      return (
        <Box display="flex" alignItems="center" gap={1}>
          <span>$</span>
          <Input
            sx={{
              background:
                modifiedFields[row.id] !== undefined
                  ? (theme) => theme.palette.custom.inputChanged
                  : 'none',
              padding: 0,
              width: 84,
            }}
            size="small"
            variant="outlined"
            value={currentCost}
            onChange={(e) => handleCostChange(row.id, e.target.value)}
            onBlur={(e) =>
              handleCostChange(row.id, parseFloat(e.target.value) || 0)
            }
          />
        </Box>
      )
    },
  },
  {
    id: 'status',
    label: 'Status',
    filterParams: {
      filterVariant: 'select',
      filterField: 'status_id',
      filterOptions: statusesOptions,
      defaultFilterValue: statusesOptions?.find(
        (status) => status.label === 'Out of Stock'
      )?.value,
      defaultOperatorValue: 'neq',
    },
    width: 150,
    format: (wheatCodeStatus) => (
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        {wheatCodeStatus?.name}
      </Stack>
    ),
  },
  {
    id: 'actions',
    label: '',
    width: 150,
    align: 'right',
    format: (_, row: T) => <TableActions actions={actions} row={row} />,
  },
]
